module.exports = __webpack_public_path__ + "img/thex-backbone.a88fa8a0.svg";